import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }
  }
`;

export const Conteudo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;

  form {
    flex: 2;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 280px;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 16px;

      & > div {
        min-width: 200px;
      }

      .select_states {
        min-width: 200px;
        display: flex;
        flex-direction: column;
        flex: 1;

        label {
          display: block;
          margin-bottom: 6px;
          font-weight: 500;
          font-size: 14px;
          font-family: 'Sora', sans-serif;
          color: #101d40;
        }
      }
    }

    .one,
    .two,
    .three {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      div:first-child {
        flex: 2;
      }
    }

    button[type='submit'] {
      max-width: 300px;
      margin: 0 auto;
    }
  }
`;

export const ContainerMap = styled.div`
  flex: 1;
  min-width: 280px;

  display: -webkit-flex;
  flex-direction: column;
  min-height: 300px;

  .localization {
    margin-top: 60px;
    padding: 10px 15px;
    font-size: 1rem;
    font-weight: 500;
    color: #616161;
    background-color: #fff;
    border-radius: 0.3rem;
    border: 1px solid #e0e0e0;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
    left: 10px !important;
  }
`;
